<template>
  <v-app>
    <Sidebar />
    <Navbar />
    <v-main>
      <v-snackbar
        v-model="showSnackbar"
        :bottom="y === 'bottom'"
        :color="color"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
      >
        {{ textSnackbar }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="() => setShowSnackbar(false)">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <router-view />
    </v-main>

    <BottomPanel v-if="isAuth" />
  </v-app>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Sidebar from "@/components/drawers/Sidebar";
import Navbar from "@/components/Navbar";
import BottomPanel from "@/components/guide/BottomPanel";

export default {
  components: {
    Sidebar,
    Navbar,
    BottomPanel,
  },
  methods: {
    ...mapMutations({
      setShowSnackbar: "snackbar/SET_SHOW_SNACKBAR",
    }),
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
  },
  computed: {
    ...mapGetters({
      isGuide: "auth/isGuide",
      isAuth: "auth/isAuth",
      call: "twilio/call",
      color: "snackbar/color",
      mode: "snackbar/mode",
      textSnackbar: "snackbar/textSnackbar",
      show: "snackbar/show",
      timeout: "snackbar/timeout",
      x: "snackbar/x",
      y: "snackbar/y",
    }),
    showSnackbar: {
      get: function () {
        return this.show;
      },
      set: function (value) {
        this.setShowSnackbar(value);
      },
    },
  },
};
</script>
